export enum EHeaderTab {
    HOME = "home",
    ABOUT = "about",
    SERVICE = "service",
    CONTACT = "contact",
}